<template>
  <div>
	  <div class="margin-top-xs">
		<!-- <span class="text-xs">当前状态:</span> -->
		<span class="firstTitle margin-top-xs"><i></i>维修记录</span>
		<dv-scroll-board :config="config" class="margin-top-sm realTimeList1">
		</dv-scroll-board>
	  </div>
		
  </div>
</template>

<script>
import { dataInterface } from '@/api/dataInterfaceApi';

export default {
  data () {
    return {
	  config: {
	  		headerBGC : 'rgba(53, 149, 147, 0.2)',
	  		headerHeight : 42,
	  		carousel : 'single',
	  		hoverPause : true,
	  		oddRowBGC : 'rgba(53, 149, 147, 0)',
	  		evenRowBGC : 'rgba(53, 149, 147, 0)',
	  		rowNum: 3, //表格行数
	  		header: [],
	  		data: []
	  },
    };
  },
  mounted () {
  },
  methods: {
    getData(data){
      // this.selectStationEnergyVehicles(data);
      //维修记录
      this.selectMaintainRecord(data);
    },
    //维修记录
    selectMaintainRecord(data={}){
      let _this = this;
      dataInterface
        .dataFaceApi({
          'enCode':'TiDB-zhandianweixiujilu',
          '@station_id':data.stationId
        })
        .then((res) => {
          if(!res) return;
          let newList = [];
          // 故障发生时间   guzhangsj
          // 故障修复时间    xiufusj
          // 故障原因   guzhangyypg
          // 处理措施   chulinr
          // 处理人员  weixiury
          // 异常零部件   f_description2
          [...res].map(item => {
						let arrlist = [
              item.guzhangsj,
              item.xiufusj,
              item.guzhangyypg,
              item.chulinr,
              item.weixiury,
              item.f_description2
            ];
						newList.push(arrlist)
          });
          console.log('newList',newList)
					_this.config = {
              headerBGC: "rgba(53, 149, 147, 0.2)",
              headerHeight: 42,
              carousel: "single",
              hoverPause: true,
              oddRowBGC: "rgba(53, 149, 147, 0)",
              evenRowBGC: "rgba(53, 149, 147, 0)",
              rowNum: 3, //表格行数
              header:["故障发生时间", "故障修复时间", "故障原因", "处理措施", "处理人员","异常零部件"],
              data:newList
					};
        })
        .catch((err) => {
          console.log(err);
        });
    },
    selectStationEnergyVehicles(data={}){
      let _this = this;
      let params = {
					"enCode":"gaojing-yidongnengyuanche-TiDB",
    			"@station_id":data.stationId
				}
      dataInterface
        .dataFaceApi(params)
        .then((res) => {
          if(!res) return;
          let newList = [];
          [...res].map(item => {
						let arrlist = [
              item.createTime,
              item.energyVehicleCode,
              item.energyVehicleType,
              item.batteryNum+'块',
            ];
						newList.push(arrlist)
          });
					_this.config = {
              headerBGC : 'rgba(53, 149, 147, 0.2)',
              headerHeight : 42,
              carousel : 'single',
              hoverPause : true,
              oddRowBGC : 'rgba(53, 149, 147, 0)',
              evenRowBGC : 'rgba(53, 149, 147, 0)',
              rowNum: 3, //表格行数
              header: ['调度时间', '调度车编码', '调度类型', '电池数量'],
							data: newList,
					};
        })
        .catch((err) => {
          console.log(err);
        });
    }, 
  }
}
</script>
<style lang="scss" scoped>
.realTimeList1{
	width: 700px;
	height: 180px;
}
.firstTitle{
  width: 700px;
  height:34px;
  font-size: 20px;
  font-family: PingFangSC-Regular, PingFang SC;
  color: #FFFFFF;
  line-height: 34px;
  display: flex;
  background: url("~@/assets/images/index/title.png") no-repeat;
  background-size: 700px 34px;
  padding-left:50px;
}
</style>